import React, { useState } from "react";
import { Container, Select, MenuItem, Typography, Paper } from "@mui/material";
import Editor from "@monaco-editor/react";

const jsonDataList = [
    { id: 1, name: "Jokers CUP 2025", data: JSON.stringify({
            "_id" : "f3a70ba5-1d03-475c-acdb-6fa78ef08789",
            "event" : {
                "name" : "Jokers CUP 2025",
                "value" : "jokers_cup_2025",
                "lock" : false
            },
            "dancesList" : [
                "Boogie-Woogie",
                "Lindy Hop",
                "Solo Jazz",
                "Balboa"
            ],
            "categoriesList" : {
                "Boogie-Woogie" : [
                    {
                        "name" : "Solo",
                        "isPair" : false
                    },
                    {
                        "name" : "Strictly",
                        "isPair" : true
                    },
                    {
                        "name" : "J&J",
                        "isPair" : true,
                        "randomPair" : true
                    }
                ],
                "Lindy Hop" : [
                    {
                        "name" : "Strictly",
                        "isPair" : true
                    },
                    {
                        "name" : "J&J",
                        "isPair" : false,
                        "randomPair" : true
                    }
                ],
                "Solo Jazz" : [
                    {
                        "name" : "Solo",
                        "isPair" : false
                    }
                ],
                "Balboa" : [
                    {
                        "name" : "Strictly",
                        "isPair" : true
                    },
                    {
                        "name" : "J&J",
                        "isPair" : true,
                        "randomPair" : true
                    }
                ]
            },
            "classList" : {
                "Boogie-Woogie" : {
                    "Solo" : [
                        "D",
                        "C",
                        "B",
                        "M"
                    ],
                    "Strictly" : [
                        "D",
                        "C",
                        "B",
                        "M"
                    ],
                    "J&J" : [
                        "Open",
                        "Advance",
                        "All Stars"
                    ]
                },
                "Lindy Hop" : {
                    "Strictly" : [
                        "Open",
                        "Advance"
                    ],
                    "J&J" : [
                        "Open",
                        "Advance"
                    ]
                },
                "Solo Jazz" : {
                    "Solo" : [
                        "Open",
                        "Advance"
                    ]
                },
                "Balboa" : {
                    "Strictly" : [
                        "Open",
                        "Advance"
                    ],
                    "J&J" : [
                        "Open",
                        "Advance"
                    ]
                }
            },
            "roundList" : {
                "Boogie-Woogie" : {
                    "Solo" : {
                        "D" : [],
                        "C" : [],
                        "B" : [],
                        "M" : []
                    },
                    "Strictly" : {
                        "D" : [
                            "fast"
                        ],
                        "C" : [
                            "fast"
                        ],
                        "B" : [
                            "fast",
                            "slow"
                        ],
                        "M" : [
                            "slow",
                            "fast",
                            "hope",
                            "slow_final",
                            "fast_final"
                        ]
                    },
                    "J&J" : {
                        "Open" : [],
                        "Advance" : [],
                        "All Stars" : []
                    }
                },
                "Lindy Hop" : {
                    "Strictly" : {
                        "Open" : [],
                        "Advance" : []
                    },
                    "J&J" : {
                        "Open" : [],
                        "Advance" : []
                    }
                },
                "Solo Jazz" : {
                    "Solo" : {
                        "Open" : [],
                        "Advance" : []
                    }
                },
                "Balboa" : {
                    "Strictly" : {
                        "Open" : [],
                        "Advance" : []
                    },
                    "J&J" : {
                        "Open" : [],
                        "Advance" : []
                    }
                }
            },
            "JudgingList" : {
                "Boogie-Woogie" : {
                    "Strictly" : {
                        "D" : [
                            "f49f7d22-0aea-4d0f-85b6-4a4427fb5e3f",
                            "58a855bf-13ec-4503-aa5f-87421f27a7b7",
                            "99835cb5-46f7-4ff6-8ddd-32e65085ed08",
                            "f49f7d22-0aea-4d0f-85b6-4a4427fb5e3f"
                        ],
                        "C" : [
                            "f49f7d22-0aea-4d0f-85b6-4a4427fb5e3f",
                            "58a855bf-13ec-4503-aa5f-87421f27a7b7"
                        ],
                        "B" : [
                            "f49f7d22-0aea-4d0f-85b6-4a4427fb5e3f",
                            "58a855bf-13ec-4503-aa5f-87421f27a7b7"
                        ],
                        "M" : [
                            "f49f7d22-0aea-4d0f-85b6-4a4427fb5e3f"
                        ]
                    }
                }
            }
        }, null, 2), type: "json" }
];

const JsonEditor = () => {
    const [selectedItem, setSelectedItem] = useState(jsonDataList[0]);

    const handleSelectChange = (event) => {
        const selected = jsonDataList.find(item => item.id === event.target.value);
        setSelectedItem(selected || jsonDataList[0]);
    };

    const handleJsonChange = (value) => {
        setSelectedItem(prev => ({ ...prev, data: value }));
    };

    return (
        <Container maxWidth="md" style={{ marginTop: 0 }}>
            <Typography variant="h6">Настройки соревнований</Typography>
            <Select fullWidth onChange={handleSelectChange} defaultValue={jsonDataList[0].id}>
                {jsonDataList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                ))}
            </Select>
            <Paper elevation={3} style={{ marginTop: 20, padding: 10, height: 750 }}>
                <Editor
                    height="100%"
                    defaultLanguage={selectedItem.type}
                    value={selectedItem.data}
                    onChange={handleJsonChange}
                    theme="vs-dark"
                    options={{ minimap: { enabled: false }, formatOnPaste: true }}
                />
            </Paper>
        </Container>
    );
};

export default JsonEditor;
